import {ParamsModel, StateParamsModel} from 'src/app/modules/common/Model'
import {DeleteLeadNatureModel} from '../Model'
import {LeadNatureModel} from '../Model/LeadNatureModel'
import {actionTypes} from './constants'

export const actions = {
  // get LeadNature
  getAllLeadNature: () => ({
    type: actionTypes.GET_ALL_LEAD_NATURE_START,
  }),
  getAllLeadNatureSuccess: (data: LeadNatureModel) => ({
    type: actionTypes.GET_ALL_LEAD_NATURE_SUCCESS,
    payload: data,
  }),
  getAllLeadNatureFinish: () => ({
    type: actionTypes.GET_ALL_LEAD_NATURE_FINISH,
  }),

  // get LeadNature DATA
  getLeadNature: (params: StateParamsModel | {status: number} = {page: 1, limit: 10}) => ({
    type: actionTypes.GET_LEAD_NATURE_START,
    payload: params,
  }),
  getLeadNatureSuccess: (data: LeadNatureModel) => ({
    type: actionTypes.GET_LEAD_NATURE_SUCCESS,
    payload: data,
  }),
  getLeadNatureFinish: () => ({
    type: actionTypes.GET_LEAD_NATURE_FINISH,
  }),

  // create key
  addLeadNature: (data: LeadNatureModel) => ({
    type: actionTypes.ADD_LEAD_NATURE_START,
    payload: data,
  }),
  addLeadNatureSuccess: (task: any) => ({
    type: actionTypes.ADD_LEAD_NATURE_SUCCESS,
    payload: task,
  }),
  addLeadNatureFinish: () => ({
    type: actionTypes.ADD_LEAD_NATURE_FINISH,
  }),
  resetLeadNature: () => ({
    type: actionTypes.RESET_LEAD_NATURE,
  }),

  //Update LeadNature
  updateLeadNature: (data: LeadNatureModel, id: string) => ({
    type: actionTypes.UPDATE_LEAD_NATURE_START,
    payload: data,
    id,
  }),

  updateLeadNatureSuccess: (data: LeadNatureModel) => ({
    type: actionTypes.UPDATE_LEAD_NATURE_SUCCESS,
    payload: data,
  }),

  updateLeadNatureFinish: () => ({
    type: actionTypes.UPDATE_LEAD_NATURE_FINISH,
  }),

  // delete key
  deleteLeadNature: (data: DeleteLeadNatureModel[]) => ({
    type: actionTypes.DELETE_LEAD_NATURE_START,
    payload: {nature: data},
  }),
  deleteLeadNatureSuccess: (data: any) => ({
    type: actionTypes.DELETE_LEAD_NATURE_SUCCESS,
    payload: data,
  }),
  deleteLeadNatureFinish: () => ({
    type: actionTypes.DELETE_LEAD_NATURE_FINISH,
  }),

  //Enable LeadNature
  enableLeadNature: (data: any) => ({
    type: actionTypes.ENABLE_LEAD_NATURE_REQUEST,
    payload: {data},
  }),

  enableLeadNatureSuccess: (task: any) => ({
    type: actionTypes.ENABLE_LEAD_NATURE_SUCCESS,
    payload: task,
  }),
  enableLeadNatureFinish: () => ({
    type: actionTypes.ENABLE_LEAD_NATURE_FINISH,
  }),

  //Disable LeadNature
  disableLeadNature: (data: any) => ({
    type: actionTypes.DISABLE_LEAD_NATURE_REQUEST,
    payload: {data},
  }),

  disableLeadNatureSuccess: (task: any) => ({
    type: actionTypes.DISABLE_LEAD_NATURE_SUCCESS,
    payload: task,
  }),
  disableLeadNatureFinish: () => ({
    type: actionTypes.DISABLE_LEAD_NATURE_FINISH,
  }),

  //Enable LeadNature
  singleEnableLeadNature: (data: any) => ({
    type: actionTypes.SINGLE_ENABLE_LEAD_NATURE_REQUEST,
    payload: {data},
  }),

  singleEnableLeadNatureSuccess: (task: any) => ({
    type: actionTypes.SINGLE_ENABLE_LEAD_NATURE_SUCCESS,
    payload: task,
  }),
  singleEnableLeadNatureFinish: () => ({
    type: actionTypes.SINGLE_ENABLE_LEAD_NATURE_FINISH,
  }),

  //Disable LeadNature
  singleDisableLeadNature: (data: any) => ({
    type: actionTypes.SINGLE_DISABLE_LEAD_NATURE_REQUEST,
    payload: {data},
  }),

  singleDisableLeadNatureSuccess: (task: any) => ({
    type: actionTypes.SINGLE_DISABLE_LEAD_NATURE_SUCCESS,
    payload: task,
  }),
  singleDisableLeadNatureFinish: () => ({
    type: actionTypes.SINGLE_DISABLE_LEAD_NATURE_FINISH,
  }),
}

